import Application from "../../Application";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import { ContentTypes } from "../common/Constants";
import CaseLawDocumentDetailsPresenter, {
  ICaseLawDocumentDetailsPresenter
} from "../presenter/CaseLawDocumentDetailsPresenter";
import { TCaseLawDocumentPresentationModel } from "../presenter/model/CaseLawDocumentPresentationModel";
import GetAllCaseLawDocumentAttachmentsInteractor from "./attachments/GetAllCaseLawDocumentAttachmentsInteractor";
import FindCaseLawDocumentInteractor from "./FindCaseLawDocumentInteractor";
import GetAllCaseLawDocumentTypesInteractor from "./GetAllCaseLawDocumentTypesInteractor";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import GetCaseLawDocumentIndexesInteractor from "./GetCaseLawDocumentIndexesInteractor";
import GetInvalidatedCaseLawDocumentsInteractor from "./GetInvalidatedCaseLawDocumentsInteractor";
import GetAllOrganisationAttachmentTypesInteractor from "../../organisations/interactors/GetAllOrganisationAttachmentTypesInteractor";
import { GenericCodebookTypes } from "../../core/common/Constants";

export default class ShowCaseLawDocumentDetailsInteractor {
  private application: Application;
  private output?: ICaseLawDocumentDetailsPresenter;
  private findCaseLawDocumentInteractor: FindCaseLawDocumentInteractor;
  private getAllCaseLawDocumentTypesInteractor: GetAllCaseLawDocumentTypesInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getCaseLawDocumentIndexesInteractor: GetCaseLawDocumentIndexesInteractor;
  private getAllOrganisationAttachmentTypesInteractor: GetAllOrganisationAttachmentTypesInteractor;
  private getAllCaseLawDocumentAttachmentsInteractor: GetAllCaseLawDocumentAttachmentsInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getInvalidatedCaseLawDocumentsInteractor: GetInvalidatedCaseLawDocumentsInteractor;
  constructor({
    application,
    findCaseLawDocument,
    getAllCaseLawDocumentTypes,
    getAllOrganisations,
    getCaseLawDocumentIndexes,
    getAllOrganisationAttachmentTypes,
    getGenericCodebook,
    getAllCaseLawDocumentAttachments,
    getInvalidatedCaseLawDocuments
  }: any) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getAllCaseLawDocumentTypesInteractor = getAllCaseLawDocumentTypes;
    this.findCaseLawDocumentInteractor = findCaseLawDocument;
    this.getCaseLawDocumentIndexesInteractor = getCaseLawDocumentIndexes;
    this.getAllOrganisationAttachmentTypesInteractor =
      getAllOrganisationAttachmentTypes;
    this.getAllCaseLawDocumentAttachmentsInteractor =
      getAllCaseLawDocumentAttachments;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getInvalidatedCaseLawDocumentsInteractor =
      getInvalidatedCaseLawDocuments;
  }
  private async getContentTypes() {
    return this.getGenericCodebookInteractor.execute(
      ContentTypes.ATTACHMENT_CONTENT_TYPE,
      false
    );
  }
  private async getAttachmentTypes(organisationId) {
    return this.getAllOrganisationAttachmentTypesInteractor.execute(
      organisationId
    );
  }
  private async getInvalidatedCaseLawDocuments(id) {
    return this.getInvalidatedCaseLawDocumentsInteractor.execute(id);
  }
  private async getAllCaseLawDocumentTypes() {
    return this.getAllCaseLawDocumentTypesInteractor.execute();
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getDecisionTypes() {
    return this.getGenericCodebookInteractor.execute(
      GenericCodebookTypes.DECISION_TYPE,
      false
    );
  }
  private async getReferenceLists(id: number, organisationId: number) {
    return Promise.all([
      this.getAllCaseLawDocumentTypes(),
      this.getAllOrganisations(),
      this.getAttachmentTypes(organisationId),
      this.getContentTypes(),
      this.getInvalidatedCaseLawDocuments(id),
      this.getDecisionTypes()
    ]);
  }

  execute(id: number) {
    this.output = CaseLawDocumentDetailsPresenter({
      application: this.application,
      initialState: {
        caseLawDocument: {} as TCaseLawDocumentPresentationModel,
        organisations: [],
        caseLawDocumentTypes: [],
        caseLawDocumentIndexes: [],
        attachmentTypes: [],
        attachmentContentTypes: [],
        caseLawDocumentAttachments: [],
        uploadedFile: undefined,
        indexHierarchyList: [],
        invalidatedCaseLawDocuments: [],
        decisionTypes: []
      }
    });
    this.findCaseLawDocumentInteractor.execute(id).then((caseLawDocument) => {
      this.getReferenceLists(id, caseLawDocument.organisationId)
        .then(
          ([
            caseLawDocumentTypes,
            organisations,
            attachmentTypes,
            attachmentContentTypes,
            invalidatedCaseLawDocuments,
            decisionTypes
          ]) =>
            this.output?.loadReferenceValues(
              caseLawDocumentTypes,
              organisations,
              attachmentTypes,
              attachmentContentTypes,
              invalidatedCaseLawDocuments,
              decisionTypes
            )
        )
        .then(() => this.output?.loadCaseLawDocument(caseLawDocument))
        .then(() => this.getAllCaseLawDocumentAttachmentsInteractor.execute(id))
        .then(this.output?.loadAttachments)
        .then(() => this.getCaseLawDocumentIndexesInteractor.execute(id))
        .then(this.output?.loadCaseLawDocumentIndexes);
    });
    return this.output;
  }
}
